"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="MessageData.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxMessageData object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxMessageData = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxInt32Pair_1 = require("./HxInt32Pair");
var HxExtractedKeyPhrase_1 = require("./HxExtractedKeyPhrase");
var HxMessageData = /** @class */ (function (_super) {
    __extends(HxMessageData, _super);
    function HxMessageData(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxMessageData, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxMessageData.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '578':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case 'CD1':
                        this.actionableMessageCard = v;
                        break;
                    case '830':
                        this.addedRecipientCount = v;
                        break;
                    case '9F2':
                        this.addedRecipientsId = new HxObjectID_1.default(v);
                        break;
                    case '544':
                        this.attachmentsId = new HxObjectID_1.default(v);
                        break;
                    case '592':
                        this.bccRecipientsId = new HxObjectID_1.default(v);
                        break;
                    case '54F':
                        this.bodyEncoding = v;
                        break;
                    case '76D':
                        var bodyOffsetsValues = v;
                        this.bodyOffsets = new Array(bodyOffsetsValues.length);
                        for (var i = 0; i < bodyOffsetsValues.length; i++) {
                            this.bodyOffsets[i] = HxInt32Pair_1.deserializeHxInt32Pair(bodyOffsetsValues[i]);
                        }
                        break;
                    case '864':
                        this.canEdit = v;
                        break;
                    case '865':
                        this.canExport = v;
                        break;
                    case '866':
                        this.canExtract = v;
                        break;
                    case '867':
                        this.canForward = v;
                        break;
                    case '868':
                        this.canModifyRecipients = v;
                        break;
                    case '869':
                        this.canPrint = v;
                        break;
                    case '86A':
                        this.canReply = v;
                        break;
                    case '86B':
                        this.canReplyAll = v;
                        break;
                    case 'AF4':
                        this.canUnsubscribe = v;
                        break;
                    case '591':
                        this.ccRecipientsId = new HxObjectID_1.default(v);
                        break;
                    case 'ABE':
                        this.clientExtensionNotificationId = new HxObjectID_1.default(v);
                        break;
                    case 'ABF':
                        this.createdTime = new Date(v);
                        break;
                    case '710':
                        this.currentAtMentionsRecipientId = new HxObjectID_1.default(v);
                        break;
                    case '77E':
                        this.draftDirtyState = v;
                        break;
                    case '558':
                        this.draftSmartReplyState = v;
                        break;
                    case '553':
                        this.draftTypeOnCreate = v;
                        break;
                    case '577':
                        this.errorsId = new HxObjectID_1.default(v);
                        break;
                    case '11F3':
                        this.extractedContacts = v;
                        break;
                    case '11F4':
                        this.extractedEmailAddresses = v;
                        break;
                    case '13E3':
                        var extractedKeyPhrasesValues = v;
                        this.extractedKeyPhrases = new Array(extractedKeyPhrasesValues.length);
                        for (var i = 0; i < extractedKeyPhrasesValues.length; i++) {
                            this.extractedKeyPhrases[i] = HxExtractedKeyPhrase_1.deserializeHxExtractedKeyPhrase(extractedKeyPhrasesValues[i]);
                        }
                        break;
                    case '11F5':
                        this.extractedMeetings = v;
                        break;
                    case '13DD':
                        this.extractedOofData = v;
                        break;
                    case '11F6':
                        this.extractedPhoneNumbers = v;
                        break;
                    case '11F7':
                        this.extractedPostalAddresses = v;
                        break;
                    case '11F8':
                        this.extractedTasks = v;
                        break;
                    case '11F9':
                        this.extractedUrls = v;
                        break;
                    case '9ED':
                        this.firstBodyByteOffset = v;
                        break;
                    case 'B0C':
                        this.firstBodyEncoding = v;
                        break;
                    case '10D5':
                        this.firstBodyHashKey = v;
                        break;
                    case '9BC':
                        this.forceDownloadExternalContent = v;
                        break;
                    case '10D6':
                        this.fullBodyHashKey = v;
                        break;
                    case '55F':
                        this.hasMeeting = v;
                        break;
                    case 'B0F':
                        this.hasQuotedText = v;
                        break;
                    case '549':
                        this.htmlBodyBytes = Buffer.from(v, 'base64');
                        break;
                    case 'B10':
                        this.htmlFirstBodyBytes = Buffer.from(v, 'base64');
                        break;
                    case '551':
                        this.htmlReplyQuotedTextBytes = Buffer.from(v, 'base64');
                        break;
                    case 'AC0':
                        this.ipmClassName = v;
                        break;
                    case 'ACD':
                        this.isIRMContentExpired = v;
                        break;
                    case '15A4':
                        this.isManualLabel = v;
                        break;
                    case 'ACE':
                        this.isMissingSmimeEncryptionCertificate = v;
                        break;
                    case '54D':
                        this.isPlaintextBody = v;
                        break;
                    case 'B11':
                        this.isPlaintextFirstBody = v;
                        break;
                    case '76E':
                        this.isQuotedTextChanged = v;
                        break;
                    case '55A':
                        this.isQuotedTextPlainText = v;
                        break;
                    case '15AC':
                        this.isSenderUnverified = v;
                        break;
                    case 'ACF':
                        this.isSmimeDecryptionError = v;
                        break;
                    case '5BF':
                        var linkedCalendarEventIdsValues = v;
                        this.linkedCalendarEventIds = new Array(linkedCalendarEventIdsValues.length);
                        for (var i = 0; i < linkedCalendarEventIdsValues.length; i++) {
                            this.linkedCalendarEventIds[i] = linkedCalendarEventIdsValues[i];
                        }
                        break;
                    case '563':
                        this.meetingCancellationId = new HxObjectID_1.default(v);
                        break;
                    case '560':
                        this.meetingObjectType = v;
                        break;
                    case '561':
                        this.meetingRequestId = new HxObjectID_1.default(v);
                        break;
                    case '562':
                        this.meetingResponseId = new HxObjectID_1.default(v);
                        break;
                    case '100D':
                        this.mentionsId = new HxObjectID_1.default(v);
                        break;
                    case '53D':
                        this.messageSize = v;
                        break;
                    case '132D':
                        this.mipLabelChangeJustification = v;
                        break;
                    case 'DDD':
                        this.mipLabelId = v;
                        break;
                    case '132E':
                        this.oldMipLabelId = v;
                        break;
                    case 'AF5':
                        this.originAppointmentHeaderId = new HxObjectID_1.default(v);
                        break;
                    case '145A':
                        this.ownerReactionType = v;
                        break;
                    case '86C':
                        this.programaticAccessAllowed = v;
                        break;
                    case '55B':
                        this.quotedTextEncoding = v;
                        break;
                    case '145B':
                        this.reactionsId = new HxObjectID_1.default(v);
                        break;
                    case '543':
                        this.replyToId = new HxObjectID_1.default(v);
                        break;
                    case '56D':
                        this.rightsManagementLicenseId = new HxObjectID_1.default(v);
                        break;
                    case '7E8':
                        this.sharingMessageActionId = new HxObjectID_1.default(v);
                        break;
                    case '559':
                        this.shouldAppendQuotedText = v;
                        break;
                    case '55D':
                        this.shouldAppendReplyHeader = v;
                        break;
                    case '55C':
                        this.shouldAppendSignature = v;
                        break;
                    case '55E':
                        this.shouldDisconnectStorageAndModel = v;
                        break;
                    case '570':
                        this.smimeInformationId = new HxObjectID_1.default(v);
                        break;
                    case 'F1B':
                        this.smimeSignerCertificateValidationFetchStatus = v;
                        break;
                    case '571':
                        this.smimeSignerCertificateValidationStatus = v;
                        break;
                    case '110F':
                        this.suggestedReplyInfo_EntityId = v;
                        break;
                    case '15D5':
                        this.suggestedReplyInfo_HasFileSuggestion = v;
                        break;
                    case '1110':
                        var suggestedReplyInfo_SuggestedRepliesValues = v;
                        this.suggestedReplyInfo_SuggestedReplies = new Array(suggestedReplyInfo_SuggestedRepliesValues.length);
                        for (var i = 0; i < suggestedReplyInfo_SuggestedRepliesValues.length; i++) {
                            this.suggestedReplyInfo_SuggestedReplies[i] = suggestedReplyInfo_SuggestedRepliesValues[i];
                        }
                        break;
                    case '57A':
                        this.tailoredDetails = v;
                        break;
                    case '5A3':
                        this.tailoredDetailsChangeNumber = v;
                        break;
                    case '944':
                        this.tailoredStatus = v;
                        break;
                    case '135D':
                        var toDoTaskIdsValues = v;
                        this.toDoTaskIds = new Array(toDoTaskIdsValues.length);
                        for (var i = 0; i < toDoTaskIdsValues.length; i++) {
                            this.toDoTaskIds[i] = toDoTaskIdsValues[i];
                        }
                        break;
                    case '135E':
                        this.toDoTasksId = new HxObjectID_1.default(v);
                        break;
                    case '590':
                        this.toRecipientsId = new HxObjectID_1.default(v);
                        break;
                    case '9CC':
                        this.truncatedState = v;
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxMessageData.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getAddedRecipients = function (sessionId) {
        return this.activeSet.getCollection(this.addedRecipientsId, sessionId);
    };
    HxMessageData.prototype.getAttachments = function (sessionId) {
        return this.activeSet.getCollection(this.attachmentsId, sessionId);
    };
    HxMessageData.prototype.getBccRecipients = function (sessionId) {
        return this.activeSet.getCollection(this.bccRecipientsId, sessionId);
    };
    HxMessageData.prototype.getCcRecipients = function (sessionId) {
        return this.activeSet.getCollection(this.ccRecipientsId, sessionId);
    };
    HxMessageData.prototype.getClientExtensionNotification = function (sessionId) {
        return this.activeSet.getCollection(this.clientExtensionNotificationId, sessionId);
    };
    HxMessageData.prototype.getCurrentAtMentionsRecipient = function (sessionId) {
        return this.activeSet.getObject(this.currentAtMentionsRecipientId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getErrors = function (sessionId) {
        return this.activeSet.getCollection(this.errorsId, sessionId);
    };
    HxMessageData.prototype.getMeetingCancellation = function (sessionId) {
        return this.activeSet.getObject(this.meetingCancellationId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getMeetingRequest = function (sessionId) {
        return this.activeSet.getObject(this.meetingRequestId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getMeetingResponse = function (sessionId) {
        return this.activeSet.getObject(this.meetingResponseId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getMentions = function (sessionId) {
        return this.activeSet.getCollection(this.mentionsId, sessionId);
    };
    HxMessageData.prototype.getOriginAppointmentHeader = function (sessionId) {
        return this.activeSet.getObject(this.originAppointmentHeaderId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getReactions = function (sessionId) {
        return this.activeSet.getCollection(this.reactionsId, sessionId);
    };
    HxMessageData.prototype.getReplyTo = function (sessionId) {
        return this.activeSet.getCollection(this.replyToId, sessionId);
    };
    HxMessageData.prototype.getRightsManagementLicense = function (sessionId) {
        return this.activeSet.getObject(this.rightsManagementLicenseId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getSharingMessageAction = function (sessionId) {
        return this.activeSet.getObject(this.sharingMessageActionId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getSmimeInformation = function (sessionId) {
        return this.activeSet.getObject(this.smimeInformationId, sessionId).then(function (result) { return result; });
    };
    HxMessageData.prototype.getToDoTasks = function (sessionId) {
        return this.activeSet.getCollection(this.toDoTasksId, sessionId);
    };
    HxMessageData.prototype.getToRecipients = function (sessionId) {
        return this.activeSet.getCollection(this.toRecipientsId, sessionId);
    };
    return HxMessageData;
}(HxObject_1.default));
exports.HxMessageData = HxMessageData;
exports.default = HxMessageData;
